//const axios = require('axios').default;
import { prepareRequest } from "../../index.js";
import { setParamsToURL } from "../../index.js"
import { CART_API_URL_LIST } from "../../routes/cart/index.js";
import store from '../../../state/store';

async function addStockToCart(params, body) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(CART_API_URL_LIST.CART_ADD_STOCK_URL, params),
        post: body
    }
    return prepareRequest(config, request, true);
}

async function deleteStockFromCart(params, body) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(CART_API_URL_LIST.CART_STOCK_DELETE_URL, params),
        post: body
    }
    return prepareRequest(config, request, true);
}

async function updateCartStock(params, body) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(CART_API_URL_LIST.CART_UPDATE_STOCK_URL, params),
        post: body
    }
    return prepareRequest(config, request, true);
}

async function updateCartPaymentMethod(params, body) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(CART_API_URL_LIST.CART_CHANGE_PAYMENT_METHOD_URL, params),
        post: body
    }
    return prepareRequest(config, request, true);
}

async function getSingleCartList(params, body) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(CART_API_URL_LIST.CART_SINGLE_LIST_URL, params),
        post: body
    }
    return prepareRequest(config, request, false, false);
}

export {
    addStockToCart,
    getSingleCartList,
    deleteStockFromCart,
    updateCartStock,
    updateCartPaymentMethod
};
